import React from 'react'

import { IconProps } from '../../../common/types'

const FlashIcon: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 20 21" fill="none">
      <path
        d="M10.8333 8.80159V2.96826L3.33325 12.1349H9.16659L9.16659 17.9683L16.6666 8.80159L10.8333 8.80159Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FlashIcon
